import React from "react";
import Helmet from "react-helmet";
import FormConsultar from "../../components/paet/FormConsultar";

export default function Consulta() {
    return (
        <>
            <Helmet>
                <title>Retiro Enfermos Terminales AFP Modelo | Solicitud de Retiro Enfermos Terminales | AFP Modelo</title>
                <meta name="description" content={``} />
                <meta name="robots" content="noindex, follow" />
            </Helmet>
            <section>
                <div className="container">
                    <div className="center h1">
                        Retiro de fondos con AFP Modelo
                    </div>
                    <div className="center h2">
                        INFÓRMATE Y HAZ EL RETIRO DE TUS FONDOS
                    </div>
                    <div className="card formulario mt-5 mb-5">
                        <div className="card-header">
                            <div className="form-row">
                                <div className="titulo">
                                    Retiro de Pensión Anticipada por Enfermedad Terminal (PAET)
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="subtitulo mt-3">
                                    Para ver el estado de tu solicitud debes ingresar el RUT del afiliado y el número de la solicitud que enviamos al correo electrónico ingresado.
                                </div>
                            </div>
                        </div>
                        <div className="card-body paet">
                            <FormConsultar />
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}